import { motion } from 'framer-motion'

export default function LoadingSpinner({ text = 'Loading...', size = 'md' }) {
  const sizeMap = {
    sm: { outer: 24, inner: 16, stroke: 2 },
    md: { outer: 48, inner: 32, stroke: 3 },
    lg: { outer: 80, inner: 56, stroke: 4 },
  }
  const { outer, inner, stroke } = sizeMap[size] ?? sizeMap.md
  const r = inner / 2 - stroke / 2
  const circ = 2 * Math.PI * r

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-12">
      <div className="relative" style={{ width: outer, height: outer }}>
        {/* Background ring */}
        <svg
          width={outer}
          height={outer}
          style={{ position: 'absolute', top: 0, left: 0 }}
        >
          <circle
            cx={outer / 2}
            cy={outer / 2}
            r={r}
            fill="none"
            stroke="rgba(255,255,255,0.08)"
            strokeWidth={stroke}
          />
        </svg>
        {/* Spinning arc */}
        <motion.svg
          width={outer}
          height={outer}
          style={{ position: 'absolute', top: 0, left: 0 }}
          animate={{ rotate: 360 }}
          transition={{ duration: 1.2, repeat: Infinity, ease: 'linear' }}
        >
          <circle
            cx={outer / 2}
            cy={outer / 2}
            r={r}
            fill="none"
            stroke="#00d4ff"
            strokeWidth={stroke}
            strokeDasharray={`${circ * 0.65} ${circ * 0.35}`}
            strokeLinecap="round"
          />
        </motion.svg>
        {/* Inner counter-rotating arc */}
        <motion.svg
          width={outer}
          height={outer}
          style={{ position: 'absolute', top: 0, left: 0 }}
          animate={{ rotate: -360 }}
          transition={{ duration: 2.0, repeat: Infinity, ease: 'linear' }}
        >
          <circle
            cx={outer / 2}
            cy={outer / 2}
            r={Math.max(2, r * 0.6)}
            fill="none"
            stroke="rgba(124, 58, 237, 0.6)"
            strokeWidth={stroke * 0.75}
            strokeDasharray={`${circ * 0.3} ${circ * 0.7}`}
            strokeLinecap="round"
          />
        </motion.svg>
      </div>

      {text && (
        <motion.p
          className="text-slate-400 text-sm font-medium"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        >
          {text}
        </motion.p>
      )}
    </div>
  )
}

export function SkeletonCard({ className = '' }) {
  return (
    <div className={`glass-card p-4 ${className}`}>
      <div className="space-y-3">
        <div className="h-4 w-2/3 rounded shimmer" />
        <div className="h-8 w-1/3 rounded shimmer" />
        <div className="h-3 w-1/2 rounded shimmer" />
      </div>
    </div>
  )
}

export function SkeletonTable({ rows = 8 }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-12 rounded-lg shimmer" style={{ animationDelay: `${i * 0.05}s` }} />
      ))}
    </div>
  )
}
